import React from "react";
import { BodyBuilder } from "../../../exports/Images";
import {
  convertStraight,
  convertTimeRangeHHMMSS,
  formattedAmount,
} from "../../common-data/Converts";

const ProfileInfo = ({ info, isGymInfo, totalGymCto }) => {
  return (
    <div
      className={`profile-info-container ${isGymInfo ? "only-gym-info" : ""}`}
    >
      <div className="profile-info">
        {!isGymInfo ? (
          <div className="profile-box profile-img">
            <img src={BodyBuilder} alt="profile" />
          </div>
        ) : null}

        <div className="profile-box profile-detail">
          <div className="detail-box">
            <p className="detail-head">Gym Name: </p>
            <span className="details-value">{info?.gym_name || "NA"}</span>
          </div>

          {isGymInfo ? (
            <div className="detail-box">
              <p className="detail-head">Total CTO: </p>
              <span className="details-value">
                ₹{formattedAmount(totalGymCto)}
              </span>
            </div>
          ) : null}

          {!isGymInfo ? (
            <>
              <div className="detail-box">
                <p className="detail-head">{info?.who} Name: </p>
                <span className="details-value">{info?.name || "NA"}</span>
              </div>
              <div className="detail-box">
                <p className="detail-head">{info?.who} Mobile: </p>
                <span className="details-value">{info?.mobile || "NA"}</span>
              </div>
              <div className="detail-box">
                <p className="detail-head">{info?.who} email: </p>
                <span className="details-value lower">
                  {info?.email || "NA"}
                </span>
              </div>
              {info?.who === "trainer" ? (
                <div className="detail-box">
                  <p className="detail-head">Shift Timing: </p>
                  <span className="details-value">
                    {info?.shiftTiming || "-"}
                  </span>
                </div>
              ) : null}
              <div className="detail-box">
                <p className="detail-head">Last Checkin: </p>
                <span className="details-value">
                  {convertStraight(info?.last_checkin) || "-"}{" "}
                  {convertTimeRangeHHMMSS(info?.checkin_time) || ""}{" "}
                  {info?.last_checkin_days_ago
                    ? `(${info.last_checkin_days_ago?.replace(/_/g, " ")})`
                    : ""}
                </span>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
